import Step from '@mui/material/Step';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import StepLabel, { stepLabelClasses } from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { FLOWS, setCompletedPagesForHPB, setCurrentActiveStep, setCurrentFlowForHPB, setReinitiateFlow } from 'app/ducks/GlobalSlice';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { checkIfAemExists } from 'utils/commonUtils';
import './VZStepper.css';
import { checkForGWSteps, checkForPlanFirstForGW, checkIfPDPFlowFresh, getActiveStep, getBYODText, getCompletedSteps, getFlow, getPathName, getReInitiatedFlow, handleStep, isFlowChanged, reinitiateFlowIfSessionIsEmpty } from './VZStepperGetSteps';
import { CompactProgressIndicator, Accordion,Text } from '@vbg-ds/core';


const ConnectorWrapper = styled(StepConnector)({
  [`&.${stepLabelClasses.labelContainer}`]: {
    textAlign: 'start'
  },
  [`&.${stepLabelClasses.active}`]: {
    [`&.${stepLabelClasses.label}`]: {
    display: 'contents',
    alignItems: 'flex-start',
    textAlign: 'start'
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#008331',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#008331',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
   
  },
});

const StepperContainer = styled(Stepper)`
  display: flex;
  flex-direction: row;
  alignItems: flex-start;
  .MuiStepLabel-labelContainer{
  position:relative;
  top:-60px;
  }
  .MuiStepConnector-alternativeLabel{
  top:10px;
  left: calc(-95% + 16px);
  right: calc(90% + 16px);
  align-items: flex-start;
  margin-left:auto;
  justify-content:flex-end;
  }
  .MuiStepLabel-iconContainer{
  z-index:1;
  background-color:white;
  }
  @media screen and (max-width:1024px){
  .MuiStepLabel-horizontal{
  width:100% !important;
  }
  .MuiStepLabel-labelContainer{
  top:-60px;
  }
  }
  @media screen and (max-width:767px){
    .miui-stp-atv .MuiStepConnector-alternativeLabel{
      width: ${158.5 * 1.5}% !important;
    }
    .miui-stp-atv-0 .MuiStepConnector-alternativeLabel{
      right: ${({stepsCount})=>stepsCount === 4 ? "calc(65% + 55px) !important" : stepsCount === 5 ? "calc(65% + 40px) !important" : stepsCount === 6 ? "calc(65% + 30px) !important" : ""};
    }

  }
  @media screen and (min-width:950px){
  .MuiStepConnector-alternativeLabel{
  right:${({stepsCount})=>stepsCount === 3 ? "calc(90% + 50px)" : stepsCount > 5 ? "calc(90% + 14px)" : "calc(90% + 22px)"};
  left:${({stepsCount})=>stepsCount === 3 ? "calc(-95% + -3px)":"calc(-95% + 8px)"};
  }
}
`;

const DivWrapper = styled.div`
height:22px;
width:${({stepsCount})=>stepsCount > 4 ? (100 + (41 - ((stepsCount*3) + (stepsCount - (6-stepsCount))))) : '130'}.4% !important;
@media screen and (max-width:767px){
width:${({stepsCount})=>((100 + (24 - ((stepsCount-1) * 3)))-0.4)}% !important;
}
.MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel{
padding-right:10px;
padding-left:10px;
}
`;

const LabelSpan = styled.span`
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

const VZStepperChild = (props) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();

  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  const { t, ready } = useTranslation(["horizontal-progress-bar", "app"],{useSuspense:false});
  const dispatch = useDispatch()
  const globalData = useSelector((state) => state.GlobalData);
  const isFromShoppingCartBI = globalData?.isFromShoppingCartBI;
  const IsNothanksClicked = globalData?.IsNothanksClicked;
  const [stepsForVDS,setStepsForVDS] = useState([]);
  const [completedPagedForHPB, setCompletedPagedForHPB] = useState(globalData.completedPagedForHPB)
  const pageData = useSelector((state) => state.MobilityPage);
  const labelPaths = t(`progressbar.labelRedirectPaths`,{ns: "horizontal-progress-bar",returnObjects:true})
  const steps = globalData.currentFlowForHPB ? t(`progressbar.${globalData.currentFlowForHPB}`,{ns: "horizontal-progress-bar",returnObjects:true}) : []//globalData?.progressSteps //['Select device', 'Select plan', 'Select device protection', 'Review cart', 'Checkout'];
  const showProgressBar = checkIfAemExists(t("showProgressBar", { ns: "horizontal-progress-bar" }))
  const progressbarClick = checkIfAemExists(t("progressbarLabelClick", { ns: "horizontal-progress-bar" }))
  let activeStepCurrent = getActiveStep({steps,pathForDevices:t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}),currentActiveIndex:globalData.currentActiveStep,reinitiateFlow:globalData.reinitiateFlow, completedPagedForHPB: completedPagedForHPB})
  const plansFirstCategories = t('plans-first.category', { ns: "app", returnObjects: true });
  const retrieve = searchParams.get("retrieve")
  const cartId = searchParams.get("cartId")
  const isRetrieveCart = retrieve === "cart" && cartId
  const isBISelectionComplete = globalData?.isBISelectionComplete
  const isfromAgentLinkPage = globalData?.isAgentlink || globalData?.fromAgentLinkDealsPage;
  const packageTypeForByod = globalData?.agentLinkFlowType;
  // console.log("qwerty ========globalData.currentFlowForHPB: ",globalData.currentFlowForHPB, " & activeStepCurrent:", activeStepCurrent)
  useEffect(()=>{
    if(globalData.currentFlowForHPB && ready){
        const stepsForCurentFlow = globalData.currentFlowForHPB ? t(`progressbar.${globalData.currentFlowForHPB}`,{ns: "horizontal-progress-bar",returnObjects:true}) : []
        if(stepsForCurentFlow && stepsForCurentFlow.length && typeof stepsForCurentFlow == 'object'){
          let finalStep = []
          const completedSteps = getCompletedSteps({steps,pathForDevices:t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}),completedPagedForHPB:completedPagedForHPB,reinitiateFlow:globalData.reinitiateFlow,activeIndex:globalData.currentActiveStep, isPlansFirstFlow:isPlansFirstFlow, isRetrieveCart:isRetrieveCart})
          stepsForCurentFlow.map((data,index)=>{
            finalStep.push({
              "label": {
                "children": data
              },
              "readonly": false,
              "status": (completedSteps&&completedSteps.length&&completedSteps.includes(index)) ? "complete" : "open",
              "selected": globalData?.currentActiveStep === index ? true : false,
              onClick : ()=>{
                if((completedSteps&&completedSteps.length&&completedSteps.includes(index))){
                  handleStep(getBYODText({ index, text: data, pages: completedPagedForHPB }), t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}), globalData.currentFlowForHPB, navigate, labelPaths, globalData.planFirstQS , isfromAgentLinkPage, packageTypeForByod)
                }

              }
            })
          })
          if(finalStep&&finalStep.length) setStepsForVDS(finalStep)
        }

    }
  },[ready,globalData.currentFlowForHPB,completedPagedForHPB,globalData?.currentActiveStep])

    useEffect(()=>{
    if((!globalData.currentFlowForHPB && !window.location.pathname?.includes("shopping-cart")) || isFlowChanged({globalData,steps,plansFirstCategories,pageData,isFromGBCOM:props?.isLqGbcom}) || (reinitiateFlowIfSessionIsEmpty({globalData, hpbFlow: globalData.currentFlowForHPB, completedPages: globalData.completedPagedForHPB}) && !window.location.pathname?.includes("shopping-cart") && !props.dontReinitiate)
      || checkForPlanFirstForGW(globalData.currentFlowForHPB, globalData.flow, FLOWS.PLANFIRST, steps) || props.reinitiate){
      // dispatch(setCompletedPagesForHPB(undefined))
      const flow = getFlow({showProtection:globalData.metaInformation?.showProtectionFeaturesOnPDP,haveJO:globalData.selectedIndexForFWAHPB === 1 ? true : false,globalData:globalData,isFromGBCOM:props?.isLqGbcom, isFromShoppingCartBI})
      if (flow && flow != "") {
        // console.log("1234512", globalData.completedPagedForHPB)
        if(globalData.currentFlowForHPB !== flow && globalData.completedPagedForHPB && globalData.completedPagedForHPB?.length > 2) {
          if(((String(flow).includes("titleFor5G") && String(globalData.currentFlowForHPB).includes("titleFor5G")) || (String(flow).includes("titleForLTE") && String(globalData.currentFlowForHPB).includes("titleForLTE")))) dispatch(setCompletedPagesForHPB([]))
          else dispatch(setCompletedPagesForHPB([globalData.completedPagedForHPB[globalData.completedPagedForHPB.length - 1]]))
        }
        dispatch(setCurrentFlowForHPB(flow))
        activeStepCurrent=0
        dispatch(setCurrentActiveStep(0))
        // if (globalData?.currentActiveStep === steps?.length - 2) {
        // dispatch(setCompletedPagesForHPB([]))
        // }
      }
    } else if(window.location.pathname?.includes("devices/all") && !globalData.currentFlowForHPB) {
      const flow = getFlow({showProtection:globalData.metaInformation?.showProtectionFeaturesOnPDP,haveJO:globalData.selectedIndexForFWAHPB === 1 ? true : false,globalData:globalData})
      if (flow && flow != "") {
        dispatch(setCurrentFlowForHPB(flow))
        activeStepCurrent = 0
        dispatch(setCurrentActiveStep(0))
      }
    }
  },[globalData.metaInformation?.showProtectionFeaturesOnPDP,globalData.currentFlowForHPB,globalData.selectedIndexForFWAHPB,globalData.category,globalData.categoryForHPB])

  useEffect(() => {
    if(globalData?.currentActiveStep < activeStepCurrent)
      dispatch(setCurrentActiveStep(activeStepCurrent))
  }, [[activeStepCurrent]])

  useEffect(() => {
    let flow = globalData.currentFlowForHPB
    let planFirstFlow = false
    if (globalData.reinitiateFlow) {
      if (((globalData.currentFlowForHPB === 'planFirstSteps' || globalData.currentFlowForHPB === 'planFirstStepsWithProtection')
                && (globalData.flow === 'plans-first' && globalData.isPlanFirstFlowCompleted && !globalData.isEditPlansFlow)) 
            // || ((globalData.currentFlowForHPB === 'titleForLTEWithJOWithProtection' || globalData.currentFlowForHPB === 'titleForLTEWithJO') && activeStepCurrent > 2)
          ) {
        planFirstFlow = true
        flow = getFlow({ showProtection: globalData.metaInformation?.showProtectionFeaturesOnPDP, haveJO: globalData.selectedIndexForFWAHPB === 1 ? true : false, globalData: globalData })
        if (flow && flow != "") {
          dispatch(setCurrentFlowForHPB(flow))
          activeStepCurrent = 0
          dispatch(setCurrentActiveStep(0))
        }
      }

      const { completedSteps, activeStep } = getReInitiatedFlow({
        completedPagedForHPB: completedPagedForHPB, flow: flow, getIndexFromAEM: t("progressbar.getIndexForReInitiatedFlow",
          { ns: "horizontal-progress-bar", returnObjects: true }), currentActiveStep: globalData?.currentActiveStep, planFirstFlow,
          pathForDevices:t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true})
      })
      let activeStepValue = getActiveStep({steps,pathForDevices:t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}),
        currentActiveIndex:globalData.currentActiveStep,reinitiateFlow:globalData.reinitiateFlow, completedPagedForHPB: completedSteps})
      setCompletedPagedForHPB(completedSteps)
      dispatch(setCompletedPagesForHPB(completedSteps))
      dispatch(setCurrentActiveStep(activeStepValue))
      dispatch(setReinitiateFlow(false))
    }
  }, [globalData.reinitiateFlow])

  useEffect(() => {
    if (!globalData.reinitiateFlow) {
      const completedPages = checkForGWSteps(completedPagedForHPB)
      setCompletedPagedForHPB(completedPages)
      dispatch(setCompletedPagesForHPB(completedPages))
    }
  }, [])

  useEffect(() => {

    const oneTalkFlow = completedPagedForHPB && typeof completedPagedForHPB === "object" && completedPagedForHPB.length && completedPagedForHPB.filter(page => page?.includes("desk-conference-phones") || page?.includes("accessories")).length > 0

    if ((globalData.flow === 'plans-first' && !globalData.isPlanFirstFlowCompleted) || oneTalkFlow) {
      const completedPages = getPathName({ storedPath: completedPagedForHPB, isPlanFirst: globalData.flow === 'plans-first' && !globalData.isPlanFirstFlowCompleted, isEditPlans: globalData.isEditPlansFlow })
      setCompletedPagedForHPB(completedPages)
      dispatch(setCompletedPagesForHPB(completedPages))
    }
    if(globalData.currentFlowForHPB === "oneTalkSteps" && !window.location.pathname.includes("desk-conference-phones") && (window.location.pathname?.includes("smart") 
      || window.location.pathname?.includes("laptop") || window.location.pathname?.includes("phone")  || window.location.pathname?.includes("tablets") || window.location.pathname?.includes("hotspot"))) {
      const flow = getFlow({showProtection:globalData.metaInformation?.showProtectionFeaturesOnPDP,haveJO:globalData.selectedIndexForFWAHPB === 1 ? true : false,globalData:globalData})
      if (flow && flow != "") {
        dispatch(setCurrentFlowForHPB(flow))
        activeStepCurrent = 0
        dispatch(setCurrentActiveStep(0))
      }
    }
    if(window.location.pathname?.includes("devices/") && steps.length == 4 && (globalData.currentActiveStep == 1 || globalData.currentActiveStep ==2)) {
      const flow = getFlow({showProtection:globalData.metaInformation?.showProtectionFeaturesOnPDP,haveJO:globalData.selectedIndexForFWAHPB === 1 ? true : false,globalData:globalData})
      if (flow && flow != "") {
        dispatch(setCurrentFlowForHPB(flow))
        activeStepCurrent = 0
        dispatch(setCurrentActiveStep(0))
      }
    }
  if(window.location.pathname?.includes("shop/shopping-cart") && isFromShoppingCartBI && (IsNothanksClicked || !isBISelectionComplete) ) {
      const flow = getFlow({showProtection:globalData.metaInformation?.showProtectionFeaturesOnPDP,haveJO:globalData.selectedIndexForFWAHPB === 1 ? true : false,globalData:globalData, isFromShoppingCartBI})
      if (flow && flow != "") {
        dispatch(setCurrentFlowForHPB("deviceFirstSteps"))
      }
    }
  }, [window.location.pathname])

  useEffect(() => {
    if((isRetrieveCart || (globalData.completedPagedForHPB && globalData.completedPagedForHPB?.length === 0) 
      || (globalData.completedPagedForHPB && globalData.completedPagedForHPB?.length === 1 && globalData.completedPagedForHPB?.includes('shop/shopping-cart')))
    && !(String(globalData.currentFlowForHPB).includes("titleFor5G") || String(globalData.currentFlowForHPB).includes("titleForLTE"))) {
      dispatch(setCurrentFlowForHPB(""))
      dispatch(setCompletedPagesForHPB([]))
      // const pages = ["devices/smartphones", "shop/plans"]
      // dispatch(setCompletedPagesForHPB(pages))
    }
  }, [])

  const CompletedIcon = (props) => {
    const { active, completed, className,icon } = props;
    if (completed) {
      return (
        <div data-track={`Progress Bar:${steps[icon-1]}`} className='chck-mrk-outline' style={{ cursor: progressbarClick ? 'pointer' : 'default' }} onClick={handleStep(getBYODText({ index:(icon-1), text: steps[icon-1], pages: completedPagedForHPB }), t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}), globalData.currentFlowForHPB, navigate, labelPaths, globalData.planFirstQS , isfromAgentLinkPage , packageTypeForByod)}>
          <Checkmark/>
          {/* <img src={`${window?.mbtGlobal?.assetsBaseUrl}/assets/images/CheckMark.svg`} alt="checkmark" width={'12px'} height={'9px'}/> */}
	        {/* <Checkmark color={'white'} size="small" /> */}
        </div>
      )
    }
    else {
      return <div style={{ position:'relative',top:'-1px',marginTop: '2px', width: '20px', height: '20px', borderRadius: '50%', border: active ? '2px solid #008331' : '2px solid #D8DADA', cursor: active && progressbarClick ? 'pointer' : 'default' }} onClick={active ? handleStep(getBYODText({ index:(icon-1), text: steps[icon-1], pages: completedPagedForHPB }), t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}), globalData.currentFlowForHPB, navigate, labelPaths, globalData.planFirstQS, isfromAgentLinkPage, packageTypeForByod) : ''}></div>
    }
  }

  const isPlansFirstFlow = (globalData.currentFlowForHPB === 'planFirstSteps' || globalData.currentFlowForHPB === 'planFirstStepsWithProtection')
                              && (globalData.flow === 'plans-first' && globalData.isEditPlansFlow)
  const show25Percent = t("progressbar.show25PercentProgress",{ns: "horizontal-progress-bar",returnObjects:true})
  const completedSteps = getCompletedSteps({steps,pathForDevices:t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}),completedPagedForHPB:completedPagedForHPB,reinitiateFlow:globalData.reinitiateFlow,activeIndex:globalData.currentActiveStep, isPlansFirstFlow:isPlansFirstFlow, isRetrieveCart:isRetrieveCart})
  const isPDPActive = checkIfPDPFlowFresh({deviceName:globalData?.storeGridwallPDP,accessoryName:globalData?.storeAccessoryPDP,completedSteps:completedPagedForHPB,activeIndex:globalData.currentActiveStep, steps})
  let classNameForActive = 'miui-stp-atv'
  if(!!show25Percent && show25Percent.length && typeof show25Percent == "object" && show25Percent.includes(globalData.currentFlowForHPB) ){
    if(isPDPActive) classNameForActive = 'miui-stp-atv-grd-75 miui-stp-atv'
    else classNameForActive = 'miui-stp-atv-grd miui-stp-atv'
  }
  // console.log("qwerty ========completedSteps: ",completedSteps, completedPagedForHPB)
  const classNameForMobile = ` vz-stepper-wdth-mob-${(steps && steps.length) ?  steps.length: ''}`
  if(stepsForVDS && stepsForVDS.length){
    if(isMobile){
      return(
        <div style={{width:'100%'}} >
        <Accordion
        behavior="singleOpen"
        id="vz-stppr-isMobile-nw"
        fullBleed={true}
        contentWidth="100%"
        width={'100%'}
        items={
          [
             {
              opened:false,
              children:  <div className='new-vz-stppr'>
                  <CompactProgressIndicator
                    items={[...stepsForVDS]}
                    labelPosition={props?.orientation ? props?.orientation : "top"}
                    orientation="vertical"
                    surface="lightPrimary"
                  />
              </div> ,
              header: {
                fullBleed:true,
                ariaLabel: '',
                title: {
                  children: 
                    <div style={{display:'flex',gap:'8px',alignItems:'flex-start'}}>
                      <div className='vz-stppr-icon-btn'/>
                      <div>
                  <Text kind='body' size='small' bold={true} >Step {globalData?.currentActiveStep+1}/{stepsForVDS.length}</Text>
                   <Text kind='body' size='small' bold={true} >{steps[globalData?.currentActiveStep]}</Text>
                  </div>
                  </div>
                 
                }
              },
              trigger: {
                closeLabel: 'Collapse',
                openLabel: 'Show all'
                
              },
              triggerElement: 'link'
            }
          ]
        }
        >
      
  </Accordion>
  </div>
      )
    }
  else{
  return (
    <div className='new-vz-stppr'>
       <CompactProgressIndicator
    items={[...stepsForVDS]}
    labelPosition={props?.orientation ? props?.orientation : "top"}
    orientation="horizontal"
    surface="lightPrimary"
  />
  </div>
  )
}
  }else return <></>
  // return (
  //   <div className={!isMobile ? 'vz-stepper-main-container vz-stepper-main-container-padding' : 'vz-stepper-main-container'}>
  //   { (globalData.metaInformation?.showUpperFunnelProgressBar && showProgressBar) ? 
  //   <div className="full-width-stpper">
  //   <DivWrapper stepsCount={(steps && steps.length) ? steps.length : 0} className={((steps && steps.length ===3 ) ? 'vz-stpper-3' : 'vz-stpper-wdth')+classNameForMobile}>
  //     <StepperContainer
  //       stepsCount = {(steps && steps.length) ? steps.length : 0}
  //       alternativeLabel={true}
  //       connector={<ConnectorWrapper />}
  //       orientation={'horizontal'}
  //       activeStep={globalData?.currentActiveStep}>
  //       {(steps && steps instanceof Array) && steps.map((label, index) => (
  //         <Step key={label} completed={completedSteps.includes(index) ? true : false} className={(index === (globalData?.currentActiveStep +  1)) ? classNameForActive :(index === globalData?.currentActiveStep ) ? 'miui-stp-atv-0' : ''} style={{paddingBottom:0}}>
  //           <StepLabel 
  //           // onClick={progressbarClick && (completedSteps.includes(index) || index === globalData?.currentActiveStep) && handleStep(getBYODText({ index, text: label, pages: completedPagedForHPB }), t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}), globalData.currentFlowForHPB, navigate, labelPaths, globalData.planFirstQS, isfromAgentLinkPage, packageTypeForByod)} 
  //           StepIconComponent={CompletedIcon} style={{alignItems: 'flex-start', width: isMobile ? '40%' : ''}}>
  //             <div size="small" style={{ display: 'flex', alignItems: 'self-start' }} className='mb-vw-lbl'>
  //               <Text kind="micro" size='small' bold={(index === globalData?.currentActiveStep) ? true : false}>
  //                 {progressbarClick && (completedSteps.includes(index) || index === globalData?.currentActiveStep) ?
  //                   <LabelSpan data-track={`Progress Bar:${label}`} onClick={handleStep(getBYODText({ index, text: label, pages: completedPagedForHPB }), t(`progressbar.pathForDeviceFirstSteps`,{ns: "horizontal-progress-bar",returnObjects:true}), globalData.currentFlowForHPB, navigate, labelPaths, globalData.planFirstQS , isfromAgentLinkPage, packageTypeForByod)}>
  //                     {isMobile ? index === globalData?.currentActiveStep ? getBYODText({ index, text: label, pages: completedPagedForHPB }) : '' : getBYODText({ index, text: label, pages: completedPagedForHPB })}
  //                   </LabelSpan>
  //                   :
  //                   isMobile ? index === globalData?.currentActiveStep ? getBYODText({ index, text: label, pages: completedPagedForHPB }) : '' : getBYODText({ index, text: label, pages: completedPagedForHPB })
  //                 }
  //               </Text>
  //             </div>
  //           </StepLabel>
  //         </Step>
  //       ))}
  //     </StepperContainer>      
  //   </DivWrapper>
  //   </div>:<></>}
  //   </div>
  // )
}

export const VZStepper = (props)=>{
  const { t } = useTranslation(["app"]);
  // const [loadVZStepper, setLoadVZStepper] = useState(false)
  const showProgressBar = checkIfAemExists(t("progressbar.enableProgressBar", { ns: "app" }))
  //   useEffect(()=>{
  //   const enableLazyLoad = checkIfAemExists(t("enabelVZStepperLazyLoad",{ ns: "app" }))
  //   if(enableLazyLoad){
  //   const abcd = setInterval(()=>{
  //     if (document.readyState == "complete") {
  //       clearInterval(abcd)
  //       setLoadVZStepper(checkIfAemExists(t("progressbar.enableProgressBar", { ns: "app" })))
  //     }
  //   },2000)
  // }else {
  //   setLoadVZStepper(checkIfAemExists(t("progressbar.enableProgressBar", { ns: "app" })))
  // }
  // },[])

  if(showProgressBar) {
    return <VZStepperChild {...props}/>
  }
  return <></>
}

const Checkmark = ()=>(
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.792 0.302734L12 1.36721L4.21613 8.25622L0 4.54626L1.20503 3.47916L4.21317 6.12728L10.792 0.302734Z" fill="white"/>
</svg>

)
